import { useState } from "react";
import { useFormikContext } from "formik";
import type { Tenant } from "../../../models/tenant";

interface BatchFormValues {
  batchIds: number[];
}

/**
 * État partagé des modales d'action en masse : la liste de locataires du lot
 * (champ Formik `batchIds`, dont l'utilisateur peut retirer des locataires) et
 * le locataire actif (celui dont l'aperçu PDF est affiché).
 */
export function useBatchSelection(tenantsById: Record<number, Tenant>) {
  const { values, setFieldValue } = useFormikContext<BatchFormValues>();
  const { batchIds } = values;
  const [activeTenantId, setActiveTenantId] = useState<number | null>(
    batchIds[0] ?? null,
  );

  const batchTenants = batchIds
    .map((id) => tenantsById[id])
    .filter((t): t is Tenant => Boolean(t));

  function removeFromBatch(tenantId: number) {
    const next = batchIds.filter((id) => id !== tenantId);
    setFieldValue("batchIds", next);
    if (activeTenantId === tenantId) {
      setActiveTenantId(next[0] ?? null);
    }
  }

  return {
    batchIds,
    batchTenants,
    activeTenantId,
    setActiveTenantId,
    removeFromBatch,
  };
}
